import { h } from 'preact';
import { PageLoading } from '../PageLoading';
import { T } from '../../../styles/tokens';
import type { ComponentShowcase } from '../registry';

export const showcase: ComponentShowcase = {
  name: 'PageLoading',
  category: '⏳ Loading',
  description: 'Tela de loading completa com 3 variantes: default, profile, dashboard',
  usedIn: ['AgentesPage', 'ChatHubPage', 'Profile'],
  example: () => (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 }}>
      {(['default', 'profile', 'dashboard'] as const).map(v => (
        <div key={v} style={{ border: '1px solid rgba(255,255,255,0.06)', borderRadius: 8, overflow: 'hidden', maxHeight: 180 }}>
          <div style={{ fontSize: 11, color: T.textSecondary, padding: '6px 10px', borderBottom: '1px solid rgba(255,255,255,0.04)' }}>{v}</div>
          <PageLoading variant={v} />
        </div>
      ))}
    </div>
  ),
};
